module.exports = __webpack_public_path__ + "static/media/Delete.ce7517aa.svg";